const rawApiBaseUrl = (import.meta.env.VITE_API_URL as string | undefined)?.trim();
const apiBaseUrl = rawApiBaseUrl ? rawApiBaseUrl.replace(/\/$/, "") : "";

/**
 * Returns the configured API base URL for browser calls.
 */
export function getApiBaseUrl(): string {
	if (apiBaseUrl) {
		return apiBaseUrl;
	}

	if (typeof window !== "undefined") {
		return window.location.origin;
	}

	return "";
}

/**
 * Builds an absolute API URL under /v1 from a route path.
 */
export function apiUrl(path: string): string {
	const normalizedPath = path.startsWith("/") ? path : `/${path}`;
	const apiPath = normalizedPath.startsWith("/v1") ? normalizedPath : `/v1${normalizedPath}`;
	return `${getApiBaseUrl()}${apiPath}`;
}

/**
 * Fetch helper for API requests with credentials enabled by default.
 */
export function apiFetch(path: string, init?: RequestInit): Promise<Response> {
	return fetch(apiUrl(path), {
		credentials: init?.credentials ?? "include",
		...init,
	});
}
